export const STYLE = [
  'alignContent',
  'alignItems',
  'alignSelf',
  'appRegion',
  'background',
  'backgroundColor',
  'backgroundImage',
  'backgroundSize',
  'borderBottomColor',
  'borderBottomLeftRadius',
  'borderBottomRightRadius',
  'borderBottomStyle',
  'borderBottomWidth',
  'borderColor',
  'borderLeftColor',
  'borderLeftStyle',
  'borderLeftWidth',
  'borderRightColor',
  'borderRightStyle',
  'borderRightWidth',
  'borderStyle',
  'borderTopColor',
  'borderTopLeftRadius',
  'borderTopRightRadius',
  'borderTopStyle',
  'borderTopWidth',
  'borderWidth',
  'bottom',
  'clipPath',
  'color',
  'cursor',
  'fill',
  'filter',
  'flex',
  'flex-grow',
  'flexBasis',
  'flexDirection',
  'flexFlow',
  'flexShrink',
  'flexWrap',
  'fontFamily',
  'fontSize',
  'fontStyle',
  'fontWeight',
  'height',
  'hyphens',
  'justifyContent',
  'left',
  'letterSpacing',
  'lineHeight',
  'marginBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'maxHeight',
  'maxWidth',
  'minHeight',
  'minWidth',
  'opacity',
  'outlineColor',
  'outlineOffset',
  'outlineStyle',
  'outlineWidth',
  'overflowWrap',
  'overflowX',
  'overflowY',
  'paddingBottom',
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'pointerEvents',
  'position',
  'resize',
  'right',
  'shadowColor',
  'shadowOffsetX',
  'shadowOffsetY',
  'shadowRadius',
  'shadowSpread',
  'stroke',
  'textAlign',
  'textDecoration',
  'top',
  'transform',
  'transformOrigin',
  'transition',
  'userSelect',
  'whiteSpace',
  'width',
  'wordBreak',
  'wordSpacing',
  'wordWrap',
  'zIndex',
  // '@fontFace',
  // '@keyframes',
  // '@media',
  // 'background',
  // 'backgroundAttachment',
  // 'backgroundBlend-mode',
  // 'backgroundClip',
  // 'backgroundOrigin',
  // 'backgroundPosition',
  // 'backgroundRepeat',
  // 'border',
  // 'borderBottom',
  // 'borderCollapse',
  // 'borderImage',
  // 'borderImageOutset',
  // 'borderImageRepeat',
  // 'borderImageSlice',
  // 'borderImageSource',
  // 'borderImageWidth',
  // 'borderLeft',
  // 'borderRadius',
  // 'borderRight',
  // 'borderSpacing',
  // 'borderTop',
  // 'boxShadow',
  // 'boxSizing',
  // 'captionSide',
  // 'clear',
  // 'clip',
  // 'column-gap',
  // 'columnCount',
  // 'columnFill',
  // 'columnRule',
  // 'columnRuleColor',
  // 'columnRuleStyle',
  // 'columnRuleWidth',
  // 'columnSpan',
  // 'columnWidth',
  // 'columns',
  // 'content',
  // 'counterIncrement',
  // 'counterReset',
  // 'direction',
  // 'display',
  // 'emptyCells',
  // 'float',
  // 'font',
  // 'font-variant',
  // 'fontSizeAdjust',
  // 'fontStretch',
  // 'hangingPunctuation',
  // 'listStyle',
  // 'listStyleImage',
  // 'listStylePosition',
  // 'listStyleType',
  // 'margin',
  // 'nav-up',
  // 'navDown',
  // 'navIndex',
  // 'navLeft',
  // 'navRight',
  // 'order',
  // 'outline',
  // 'overflow',
  // 'padding',
  // 'pageBreakAfter',
  // 'pageBreakBefore',
  // 'pageBreakInside',
  // 'perspective',
  // 'perspectiveOrigin',
  // 'quotes',
  // 'tabSize',
  // 'tableLayout',
  // 'textAlignLast',
  // 'textDecorationColor',
  // 'textDecorationLine',
  // 'textDecorationStyle',
  // 'textIndent',
  // 'textJustify',
  // 'textOverflow',
  // 'textShadow',
  // 'textTransform',
  // 'transformStyle',
  // 'transitionDelay',
  // 'transitionDuration',
  // 'transitionProperty',
  // 'transitionTimingFunction',
  // 'unicodeBidi',
  // 'verticalAlign',
  // 'visibility',
]

export const isStyle = name => STYLE.includes(name)
